import {MONTHLY, YEARLY} from "Core/periodLabels";
import {TEAMS, PRO, INDIE} from "Core/tariffTypeLabels";
import {correctPrice} from "Core/helpers/dataLayerHelper";

export default {
    [MONTHLY]: {
        [PRO]: {
            'id': 'Plan1',
            'name': 'PRO Monthly',
            //'price': correctPrice(window.plansPrices['proMonthly']),
            'brand': 'Nekki',
            'category': 'PRO',
            'variant': 'Monthly',
            'quantity': 1,
        },
        [TEAMS]: {
            'id': 'Plan3',
            'name': 'Teams Monthly',
            //'price': correctPrice(window.plansPrices['teamsMonthly']),
            'brand': 'Nekki',
            'category': 'Teams',
            'variant': 'Monthly',
            'quantity': 1,
        },
        [INDIE]: {
            'id': 'Plan5',
            'name': 'Indie',
            //'price': correctPrice(window.plansPrices['indie']),
            'brand': 'Nekki',
            'category': 'Indie',
            'variant': 'None',
            'quantity': 1,
        },
    },
    [YEARLY]: {
        [PRO]: {
            'id': 'Plan2',
            'name': 'PRO Yearly',
            //'price': correctPrice(window.plansPrices['proYearly']),
            'brand': 'Nekki',
            'category': 'PRO',
            'variant': 'Yearly',
            'quantity': 1,
        },
        [TEAMS]: {
            'id': 'Plan4',
            'name': 'Teams Yearly',
            //'price': correctPrice(window.plansPrices['teamsYearly']),
            'brand': 'Nekki',
            'category': 'Teams',
            'variant': 'Yearly',
            'quantity': 1,
        },
        [INDIE]: {
            'id': 'Plan5',
            'name': 'Indie',
            //'price': correctPrice(window.plansPrices['indie']),
            'brand': 'Nekki',
            'category': 'Indie',
            'variant': 'None',
            'quantity': 1,
        },
    }
}